(() => {
  const setupTypedHero = (scope = document) => {
    scope.querySelectorAll("[data-typed-hero-word]").forEach((node) => {
      if (node.dataset.typedHeroReady === "true") return;
      node.dataset.typedHeroReady = "true";

      const words = (node.dataset.typedWords || "")
        .split(",")
        .map((word) => word.trim())
        .filter(Boolean);

      if (!words.length) return;

      node.textContent = words[0];

      const prefersReducedMotion =
        window.matchMedia &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      const animationType = node.dataset.animationType || "typing";

      if (prefersReducedMotion || words.length === 1 || animationType === "off") return;

      const typeSpeed = Math.max(20, parseInt(node.dataset.typedSpeed, 10) || 85);
      const deleteSpeed = Math.max(20, parseInt(node.dataset.deleteSpeed, 10) || 55);
      const holdSpeed = Math.max(200, parseInt(node.dataset.holdSpeed, 10) || 1400);

      let wordIndex = 0;
      let charIndex = words[0].length;
      let deleting = true;

      if (animationType === "fade") {
        const runFade = () => {
          node.style.opacity = 0; 
          setTimeout(() => {
            wordIndex = (wordIndex + 1) % words.length;
            node.textContent = words[wordIndex];
            node.style.opacity = 1; 
            node._typedHeroTimer = window.setTimeout(runFade, holdSpeed);
          }, 500); 
        };
        node._typedHeroTimer = window.setTimeout(runFade, holdSpeed);
        return; 
      }

      const runTyping = () => {
        const currentWord = words[wordIndex];

        if (deleting) {
          charIndex = Math.max(0, charIndex - 1);
          node.textContent = currentWord.slice(0, charIndex);

          if (charIndex === 0) {
            deleting = false;
            wordIndex = (wordIndex + 1) % words.length;
            node._typedHeroTimer = window.setTimeout(runTyping, typeSpeed);
            return;
          }

          node._typedHeroTimer = window.setTimeout(runTyping, deleteSpeed);
          return;
        }

        const nextWord = words[wordIndex];
        charIndex = Math.min(nextWord.length, charIndex + 1);
        node.textContent = nextWord.slice(0, charIndex);

        if (charIndex === nextWord.length) {
          deleting = true;
          node._typedHeroTimer = window.setTimeout(runTyping, holdSpeed);
          return;
        }

        node._typedHeroTimer = window.setTimeout(runTyping, typeSpeed);
      };

      node._typedHeroTimer = window.setTimeout(runTyping, holdSpeed);
    });
  };

  const clearTypedHero = (scope = document) => {
    scope.querySelectorAll("[data-typed-hero-word]").forEach((node) => {
      if (node._typedHeroTimer) {
        window.clearTimeout(node._typedHeroTimer);
      }
      node.dataset.typedHeroReady = "";
    });
  };

  const initHeroSnapScroll = () => {
    if (window.innerWidth < 768) return;

    const hero = document.querySelector('.typed-hero-split');
    if (!hero) return;

    const sectionWrapper = hero.closest('.shopify-section');
    if (!sectionWrapper) return;

    const nextSection = sectionWrapper.nextElementSibling;
    if (!nextSection) return;

    let scrollAccumulator = 0;
    const SCROLL_THRESHOLD = 150; 
    const SCROLL_DURATION = 1200; 
    let isAnimating = false;
    let lastScrollTime = 0;

    const smoothScrollTo = (targetY, duration) => {
      const startY = window.scrollY;
      const difference = targetY - startY;
      const startTime = performance.now();

      const easeInOutCubic = (t) => {
        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      };

      const animateScroll = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const easeProgress = easeInOutCubic(progress);

        window.scrollTo(0, startY + difference * easeProgress);

        if (progress < 1) {
          requestAnimationFrame(animateScroll);
        } else {
          isAnimating = false;
        }
      };

      isAnimating = true;
      requestAnimationFrame(animateScroll);
    };

    const handleWheel = (e) => {
      if (isAnimating) {
        e.preventDefault();
        return;
      }
      if (window.innerWidth < 768) return;

      const now = Date.now();
      const nextSectionTop = nextSection.offsetTop;

      if (now - lastScrollTime > 300) {
        scrollAccumulator = 0;
      }
      lastScrollTime = now;

      if (e.deltaY > 0 && window.scrollY < 100) {
        scrollAccumulator += Math.abs(e.deltaY);

        if (scrollAccumulator >= SCROLL_THRESHOLD) {
          e.preventDefault();
          scrollAccumulator = 0;
          smoothScrollTo(nextSectionTop, SCROLL_DURATION);
        } else {
          e.preventDefault(); 
        }
        return;
      }

      if (e.deltaY < 0 && window.scrollY > 0 && window.scrollY <= nextSectionTop + 100) {
        if (window.scrollY <= nextSectionTop + window.innerHeight * 0.3) {
          scrollAccumulator += Math.abs(e.deltaY);

          if (scrollAccumulator >= SCROLL_THRESHOLD) {
            e.preventDefault();
            scrollAccumulator = 0;
            smoothScrollTo(0, SCROLL_DURATION);
          } else {
            e.preventDefault(); 
          }
          return;
        }
      }

      scrollAccumulator = 0;
    };

    window.addEventListener('wheel', handleWheel, { passive: false });

    window.addEventListener('resize', () => {
      scrollAccumulator = 0;
      isAnimating = false;
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      setupTypedHero(document);
      initHeroSnapScroll();
    });
  } else {
    setupTypedHero(document);
    initHeroSnapScroll();
  }

  document.addEventListener("shopify:section:load", (event) => setupTypedHero(event.target));
  document.addEventListener("shopify:section:unload", (event) => clearTypedHero(event.target));

})();